import { __require as requireDist } from '../node_modules/.pnpm/typescript-event-emitter@2.1.0_@angular_core@21.2.6_rxjs@7.8.2__react@19.2.4_vue@3.5.31_typescript@5.9.3_/node_modules/typescript-event-emitter/dist/index.js';

requireDist();
//# sourceMappingURL=index.js.map
